function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M107.64 32H4.35973C2.0886 32 0.228516 30.199 0.228516 28V4C0.228516 1.801 2.0886 1.90735e-06 4.35973 1.90735e-06H107.64C109.911 1.90735e-06 111.771 1.801 111.771 4V28C111.771 30.199 109.911 32 107.64 32Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M107.64 0.641C109.553 0.641 111.109 2.148 111.109 4V28C111.109 29.852 109.553 31.359 107.64 31.359H4.35973C2.44698 31.359 0.890543 29.852 0.890543 28V4C0.890543 2.148 2.44698 0.641 4.35973 0.641H107.64ZM107.64 1.90735e-06H4.35973C2.0886 1.90735e-06 0.228516 1.801 0.228516 4V28C0.228516 30.199 2.0886 32 4.35973 32H107.64C109.911 32 111.771 30.199 111.771 28V4C111.771 1.801 109.911 1.90735e-06 107.64 1.90735e-06Z",
  fill: "#A6A6A6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.85045 6.03134C8.60775 6.27734 8.46729 6.66034 8.46729 7.15634V24.8483C8.46729 25.3443 8.60775 25.7273 8.85045 25.9733L8.91036 26.0273L19.1496 16.1173V15.8833L8.91036 5.97334L8.85045 6.03134Z",
  fill: "url(#paint0_linear_6264_130607)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5589 19.4238L19.1497 16.1188V15.8848L22.5631 12.5798L22.6395 12.6228L26.6819 14.8498C27.8355 15.4818 27.8355 16.5218 26.6819 17.1578L22.6395 19.3808L22.5589 19.4238Z",
  fill: "url(#paint1_linear_6264_130607)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6393 19.38L19.1495 16.001L8.85034 25.974C9.23351 26.364 9.85836 26.411 10.5689 26.021L22.6393 19.38Z",
  fill: "url(#paint2_linear_6264_130607)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6393 12.621L10.5689 5.98C9.85836 5.594 9.23351 5.641 8.85034 6.031L19.1495 16L22.6393 12.621Z",
  fill: "url(#paint3_linear_6264_130607)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M39.4069 8.19519C39.4069 8.86319 39.2004 9.39819 38.7934 9.79719C38.3256 10.2702 37.7162 10.5082 36.9695 10.5082C36.2558 10.5082 35.6465 10.2662 35.1466 9.78919C34.6457 9.30519 34.3958 8.71119 34.3958 8.00019C34.3958 7.28919 34.6457 6.69519 35.1466 6.21519C35.6465 5.73419 36.2558 5.49219 36.9695 5.49219C37.3248 5.49219 37.6635 5.56319 37.9868 5.69519C38.309 5.82819 38.5714 6.00819 38.7614 6.23019L38.3297 6.65219C37.9982 6.27319 37.5468 6.08619 36.9695 6.08619C36.449 6.08619 35.9976 6.26219 35.6145 6.61719C35.2354 6.97319 35.0454 7.43419 35.0454 8.00019C35.0454 8.56619 35.2354 9.03119 35.6145 9.38719C35.9976 9.73819 36.449 9.91819 36.9695 9.91819C37.5221 9.91819 37.9868 9.73819 38.3535 9.38319C38.5951 9.14819 38.7325 8.82419 38.7686 8.41019H36.9695V7.83219H39.3697C39.3987 7.95719 39.4069 8.07819 39.4069 8.19519Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.16,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M43.2149 6.19056H40.9603V7.71056H42.9929V8.28856H40.9603V9.80856H43.2149V10.3976H40.322V5.60156H43.2149V6.19056Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.16,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9023 10.3976H45.264V6.19056H43.8811V5.60156H47.2863V6.19056H45.9023V10.3976Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.16,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M49.7505 10.3976V5.60156H50.3877V10.3976H49.7505Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.16,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M53.2124 10.3976H52.5792V6.19056H51.1912V5.60156H54.6004V6.19056H53.2124V10.3976Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.16,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M61.0473 9.78119C60.5588 10.2662 59.9536 10.5082 59.2316 10.5082C58.5056 10.5082 57.9004 10.2662 57.4118 9.78119C56.9244 9.29719 56.6816 8.70319 56.6816 8.00019C56.6816 7.29719 56.9244 6.70319 57.4118 6.21919C57.9004 5.73419 58.5056 5.49219 59.2316 5.49219C59.9494 5.49219 60.5547 5.73419 61.0432 6.22319C61.5348 6.71119 61.7775 7.30119 61.7775 8.00019C61.7775 8.70319 61.5348 9.29719 61.0473 9.78119ZM57.8838 9.37919C58.2515 9.73819 58.6987 9.91819 59.2316 9.91819C59.7604 9.91819 60.2118 9.73819 60.5753 9.37919C60.942 9.02019 61.1279 8.55919 61.1279 8.00019C61.1279 7.44119 60.942 6.98019 60.5753 6.62119C60.2118 6.26219 59.7604 6.08219 59.2316 6.08219C58.6987 6.08219 58.2515 6.26219 57.8838 6.62119C57.5172 6.98019 57.3313 7.44119 57.3313 8.00019C57.3313 8.55919 57.5172 9.02019 57.8838 9.37919Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.16,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M62.6729 10.3976V5.60156H63.4475L65.856 9.33156H65.8838L65.856 8.40956V5.60156H66.4932V10.3976H65.8281L63.306 6.48356H63.2781L63.306 7.40956V10.3976H62.6729Z",
  fill: "black",
  stroke: "black",
  strokeWidth: 0.16,
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M56.5245 17.4017C54.5839 17.4017 52.9985 18.8317 52.9985 20.8047C52.9985 22.7617 54.5839 24.2067 56.5245 24.2067C58.4693 24.2067 60.0546 22.7617 60.0546 20.8047C60.0546 18.8317 58.4693 17.4017 56.5245 17.4017ZM56.5245 22.8667C55.4597 22.8667 54.5436 22.0157 54.5436 20.8047C54.5436 19.5777 55.4597 18.7417 56.5245 18.7417C57.5893 18.7417 58.5096 19.5777 58.5096 20.8047C58.5096 22.0157 57.5893 22.8667 56.5245 22.8667ZM48.8311 17.4017C46.8864 17.4017 45.3052 18.8317 45.3052 20.8047C45.3052 22.7617 46.8864 24.2067 48.8311 24.2067C50.7749 24.2067 52.3571 22.7617 52.3571 20.8047C52.3571 18.8317 50.7749 17.4017 48.8311 17.4017ZM48.8311 22.8667C47.7653 22.8667 46.8461 22.0157 46.8461 20.8047C46.8461 19.5777 47.7653 18.7417 48.8311 18.7417C49.896 18.7417 50.8121 19.5777 50.8121 20.8047C50.8121 22.0157 49.896 22.8667 48.8311 22.8667ZM39.6764 18.4447V19.8907H43.2426C43.1383 20.6987 42.8595 21.2927 42.4319 21.7067C41.9114 22.2067 41.1006 22.7617 39.6764 22.7617C37.4817 22.7617 35.7631 21.0467 35.7631 18.9217C35.7631 16.7967 37.4817 15.0817 39.6764 15.0817C40.8631 15.0817 41.7265 15.5307 42.3637 16.1127L43.4162 15.0937C42.5249 14.2697 41.3392 13.6367 39.6764 13.6367C36.6668 13.6367 34.1375 16.0077 34.1375 18.9217C34.1375 21.8357 36.6668 24.2067 39.6764 24.2067C41.303 24.2067 42.5248 23.6907 43.4854 22.7227C44.4696 21.7697 44.7764 20.4297 44.7764 19.3477C44.7764 19.0117 44.7474 18.7027 44.6958 18.4447H39.6764ZM77.1114 19.5657C76.8212 18.8047 75.9257 17.4017 74.1018 17.4017C72.2944 17.4017 70.7896 18.7807 70.7896 20.8047C70.7896 22.7107 72.2789 24.2067 74.2753 24.2067C75.8896 24.2067 76.8212 23.2537 77.2043 22.6987L76.0063 21.9257C75.6066 22.4917 75.0623 22.8667 74.2753 22.8667C73.4935 22.8667 72.9327 22.5197 72.5732 21.8357L77.2735 19.9527L77.1114 19.5657ZM72.3192 20.6987C72.2789 19.3867 73.3716 18.7147 74.1545 18.7147C74.768 18.7147 75.2885 19.0117 75.462 19.4367L72.3192 20.6987ZM68.4988 23.9997H70.0439V13.9997H68.4988V23.9997ZM65.9685 18.1597H65.9168C65.5698 17.7617 64.9078 17.4017 64.0691 17.4017C62.3092 17.4017 60.7001 18.8977 60.7001 20.8157C60.7001 22.7227 62.3092 24.2067 64.0691 24.2067C64.9078 24.2067 65.5698 23.8437 65.9168 23.4337H65.9685V23.9217C65.9685 25.2227 65.2507 25.9217 64.0929 25.9217C63.1489 25.9217 62.5633 25.2617 62.3216 24.7067L60.978 25.2497C61.3653 26.1517 62.3908 27.2617 64.0929 27.2617C65.9044 27.2617 67.433 26.2297 67.433 23.7187V17.6087H65.9685V18.1597ZM64.2013 22.8667C63.1365 22.8667 62.2452 22.0037 62.2452 20.8157C62.2452 19.6167 63.1365 18.7417 64.2013 18.7417C65.2507 18.7417 66.0779 19.6167 66.0779 20.8157C66.0779 22.0037 65.2507 22.8667 64.2013 22.8667ZM84.3451 13.9997H80.6498V23.9997H82.1907V20.2107H84.3451C86.0565 20.2107 87.7348 19.0117 87.7348 17.1047C87.7348 15.1987 86.0524 13.9997 84.3451 13.9997ZM84.3854 18.8197H82.1907V15.3907H84.3854C85.536 15.3907 86.1928 16.3157 86.1928 17.1047C86.1928 17.8787 85.536 18.8197 84.3854 18.8197ZM93.911 17.3827C92.7976 17.3827 91.6398 17.8587 91.1637 18.9137L92.5311 19.4687C92.8255 18.9137 93.3667 18.7337 93.9389 18.7337C94.7382 18.7337 95.549 19.1987 95.5614 20.0197V20.1247C95.2825 19.9687 94.6856 19.7377 93.9512 19.7377C92.4785 19.7377 90.9778 20.5227 90.9778 21.9877C90.9778 23.3277 92.1841 24.1907 93.5402 24.1907C94.5771 24.1907 95.1493 23.7377 95.5087 23.2107H95.5614V23.9837H97.0497V20.1477C97.0497 18.3747 95.6822 17.3827 93.911 17.3827ZM93.7251 22.8627C93.2211 22.8627 92.5187 22.6207 92.5187 22.0157C92.5187 21.2417 93.3946 20.9447 94.1526 20.9447C94.8312 20.9447 95.1493 21.0897 95.5614 21.2807C95.4405 22.2067 94.6174 22.8627 93.7251 22.8627ZM102.472 17.6017L100.701 21.9367H100.648L98.8168 17.6017H97.155L99.9064 23.6597L98.3365 27.0307H99.9467L104.186 17.6017H102.472ZM88.5817 23.9997H90.1268V13.9997H88.5817V23.9997Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_6264_130607",
  x1: 18.2405,
  y1: 25.0326,
  x2: 4.82153,
  y2: 11.1735,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0066,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2601,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5122,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7604,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_6264_130607",
  x1: 28.1841,
  y1: 16.0007,
  x2: 8.19161,
  y2: 16.0007,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4087,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7754,
  stopColor: "#FFA500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_6264_130607",
  x1: 20.7416,
  y1: 14.1641,
  x2: 2.54448,
  y2: -4.63002,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_6264_130607",
  x1: 6.25784,
  y1: 31.859,
  x2: 14.3837,
  y2: 23.4667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0685,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4762,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8009,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})));

var SvgGooglePlayEn = function SvgGooglePlayEn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 32,
    viewBox: "0 0 112 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlayEn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GooglePlayEn.a21e873d.svg";
export { ForwardRef as ReactComponent };